// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__110Y6","label":"Section_label__3_igs","contentWrap":"Section_contentWrap__nZ8aB","footer":"Section_footer__2Ws3Q","footerInner":"Section_footerInner__1nIpg"};